import React from 'react';
import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getAutorizacionesOtras from '../../../graphql/querys/tramites/getAutorizacionesOtras.graphql';
import deleteAutorizacionOtra from '../../../graphql/mutations/tramites/deleteAutorizacionOtra.graphql';
import getPersonaPorId from '../../../graphql/querys/personas/getPersonaPorId.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getAutorizacionesPorRango from '../../../graphql/querys/tramites/getAutorizacionesPorRango.graphql';

import { descargarCSV } from '../funciones/descargarCSV';
import convertBase64toBlob from '../../common/documentos/convertBase64toBlob';

import TablaAutorizacionesOtras from './TablaAutorizacionesOtras';

import ReImprimirNota from '../ReImprimirNota';
import { errorService } from '../../../graphql/utils/utils';

const confirm = Modal.confirm;

@compose(
  graphql(getUsuario),
  graphql(deleteAutorizacionOtra, {
    name: 'deleteAutorizacion',
    options: {
      refetchQueries: [{ query: getAutorizacionesOtras }],
    },
  })
)
class VerAutorizacionesOtras extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      listaOriginal: [],
      primeraCarga: true,
      imprimir: false,
      datosImpresion: {},
      fechaInicio: null,
      fechaFin: null,
      loadingTabla: false,
    };

    this.onDelete = this.onDelete.bind(this);

    let fechaIni = moment().subtract(7, 'd');
    fechaIni = fechaIni.toDate();

    let fechaFin = moment();
    fechaFin = fechaFin.toDate();

    this.buscarAutorizacionesPorFecha(fechaIni, fechaFin);
  }

  buscarAutorizacionesPorFecha = (fechaIni, fechaFin) => {
    this.setState({ loadingTabla: true });
    this.props.client
      .query({
        query: getAutorizacionesPorRango,
        variables: {
          fechaInicial: fechaIni,
          fechaFinal: fechaFin,
        },
      })
      .then(res => {
        // console.log("RECIBI: ");
        // console.log(res);

        this.setState(
          {
            ...this.state,
            listaTotal: res.data.getAutorizacionesPorRango,
            listaOriginal: res.data.getAutorizacionesPorRango,
            primeraCarga: false,
            loadingTabla: false,
          },
          function() {
            this.ordenarLista(1, 10);
          }
        );
      })
      .catch(err => {
        console.log('ERROR EN EL AUTORIZACIONES OTRAS POR RANGO: ');
        console.log(err);
        errorService(err, {
          fechaInicial: fechaIni,
          fechaFinal: fechaFin,
        });
        Modal.error({
          title: 'Error en la busqueda de autorizaciones',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  onDelete(id) {
    //TODO: Hacer el onDelete.
    // console.log("Se desea eliminar la autorizacion con id ", id);

    let { usuario } = this.props;

    if (usuario.rol == 'SUPERVISOR' || usuario.rol == 'FUNCIONARIO') {
      let yo = this;
      confirm({
        title: 'Realmente quiere eliminar esta autorizacion?',
        content: 'Esta accion no podrá deshacerse',
        onOk() {
          yo.props
            .deleteAutorizacion({
              variables: { _id: id },
            })
            .then(res => {
              let id = res.data.deleteAutorizacion;

              if (id) {
                yo.eliminarElementoYActualizarLista(id);

                notification.warning({
                  message: 'Autorizacion eliminada',
                  description: 'Se ha eliminado la autorizacion exitosamente',
                });
              }
            })
            .catch(err => {
              console.log(
                'Existio un error a la hora de eliminar la autorizacion'
              );
              console.log(err);
              errorService(err, {
                _id: id,
              });
              Modal.error({
                title: 'Error en la eliminacion de la autorizacion',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    } else {
      Modal.error({
        title:
          'Usted no tiene los permisos necesarios para realizar esta operación',
        content:
          'Para poder realizar esta función, debe tener mas permisos en su cuenta de los que tiene ahora mismo. Por favor, en caso de ser necesario, comuníquese con mesa de ayuda del departamento de informática.',
      });
    }
  }

  eliminarElementoYActualizarLista = idElemento => {
    //Esta funcion esta encargada de eliminar el elemento de la lista, actualizar el estado y re-generar la lista.
    let lTotal = [...this.state.listaTotal];

    // eslint-disable-next-line no-unused-vars
    let removidos = _.remove(lTotal, elem => {
      return elem._id == idElemento;
    });
    this.setState(
      {
        ...this.state,
        listaTotal: lTotal,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorNombre = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loadingTabla: true,
    });

    let listaFiltrada = _.filter(this.state.listaOriginal, certificacion => {
      return (
        certificacion.autorizante.nombre
          .toUpperCase()
          .indexOf(filtro.toUpperCase()) > -1
      );
    });

    this.setState(
      {
        ...this.state,
        loadingTabla: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorApellido = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loadingTabla: true,
    });

    let listaFiltrada = _.filter(this.state.listaOriginal, certificacion => {
      return (
        certificacion.autorizante.apellido
          .toUpperCase()
          .indexOf(filtro.toUpperCase()) > -1
      );
    });

    this.setState(
      {
        ...this.state,
        loadingTabla: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorDocumento = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loadingTabla: true,
    });

    let listaFiltrada = _.filter(this.state.listaOriginal, certificacion => {
      return (
        certificacion.autorizante.num_doc
          .toUpperCase()
          .indexOf(filtro.toUpperCase()) > -1
      );
    });

    this.setState(
      {
        ...this.state,
        loadingTabla: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.data.getAutorizaciones) {
      this.setState(
        {
          ...this.state,
          listaTotal: nextProps.data.getAutorizaciones,
          primeraCarga: false,
        },
        function() {
          this.ordenarLista(1, 10);
        }
      );
    }
  }

  ordenarLista = (numPagina, tamPagina) => {
    // console.log("Listaaaa");
    // console.log(this.state.listaTotal);
    let listaOrdenada = _.orderBy(
      this.state.listaTotal,
      [
        autorizacion => {
          // return autorizacion.autorizante.apellido.toUpperCase();
          return autorizacion.fecha_creacion;
        },
      ],
      ['desc']
    );

    let listaCorta = _.slice(
      listaOrdenada,
      0 + (numPagina - 1) * tamPagina,
      tamPagina * numPagina
    );

    this.setState({
      ...this.state,
      currentPage: numPagina,
      lista: listaCorta,
    });
  };

  onImprimir = registro => {
    if (registro.modelo_nota) {
      this.setState(
        {
          ...this.state,
          loading: true,
        },
        () => {
          this.props.client
            .query({
              query: getPersonaPorId,
              variables: {
                _id: registro.autorizante._id,
              },
            })
            .then(respuesta => {
              let persona = respuesta.data.getPersonaPorId;
              let textoOperacion = `Este tramite fue exento del pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
              if (registro && registro.venta) {
                let venta = registro.venta;
                textoOperacion = `Por este trámite se abono la suma de $${venta.importe} mediante el uso de ${venta.tipoPago}, en concepto de pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
              }
              let datosImpresion = {
                ...persona,
                fecha_creacion: new Date(registro.fecha_creacion),
                ...registro,
                autorizacion: registro.texto_autorizacion,
                numero: registro.numero,
                fecha_nacimiento: persona.fecha_nacimiento
                  ? moment(persona.fecha_nacimiento).toDate()
                  : '',
                edad: persona.fecha_nacimiento
                  ? Math.floor(
                      moment(new Date()).diff(
                        moment(persona.fecha_nacimiento),
                        'years',
                        true
                      )
                    )
                  : '',
                textoOperacion,
              };

              // console.log("Los datos de impresion es....");
              // console.log(datosImpresion);

              this.setState({
                ...this.state,
                loading: false,
                datosImpresion,
                imprimir: true,
              });
            })
            .catch(err => {
              console.log('Error en la obtencion de los datos de la persona');
              console.log(err);
              errorService(err, {
                _id: registro.autorizante._id,
              });
            });
        }
      );
    } else {
      Modal.error({
        title: 'Error con la nota modelo',
        content:
          'La nota que esta autorizacion utilizó fue eliminada o modificada, por lo que no se puede volver a imprimir este tramite. Por favor, comuniquesé con mesa de ayuda en caso de ser necesario. ',
      });
    }
  };

  // eslint-disable-next-line no-unused-vars
  onChange = (date, dateString) => {
    this.setState(
      {
        ...this.state,
        fechaInicio: date[0]
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate(),
        fechaFin: date[1]
          .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
          .toDate(),
      },
      () => {
        this.buscarAutorizacionesPorFecha(
          this.state.fechaInicio,
          this.state.fechaFin
        );
      }
    );
  };

  onDescargar = () => {
    // console.log("entre a descargar");
    let data = _.map(this.state.listaTotal, autorizacion => {
      return {
        tipo_doc: autorizacion.autorizante.tipo_doc,
        num_doc: autorizacion.autorizante.num_doc,
        nombre: autorizacion.autorizante.nombre,
        apellido: autorizacion.autorizante.apellido,
        fecha: moment(autorizacion.fecha_creacion).format('DD/MM/YYYY'),
        usuario: autorizacion.creador
          ? autorizacion.creador.apellido.toUpperCase()
          : '-',
      };
    });
    descargarCSV(
      ['Tipo Doc', 'Num Doc', 'Nombre', 'Apellido', 'Fecha', 'Usuario'],
      data,
      `ReporteDeAutorizacionesOtros-${moment().format('DD/MM/YYYY-HH:mm')}.csv`
    );
  };

  generarRecibo = base64 => {
    const base64PdfBlob = convertBase64toBlob(base64, 'application/pdf');
    const filePdf = URL.createObjectURL(base64PdfBlob);
    window.open(filePdf);
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const pagination = {
      pageSize: 10,
      current: this.state.currentPage,
      total: this.state.listaTotal ? this.state.listaTotal.length : 0,
      onChange: (page, pageSize) => {
        this.ordenarLista(page, pageSize);
      },
    };
    return (
      <div>
        {!this.state.imprimir && (
          <TablaAutorizacionesOtras
            autorizaciones={this.state.lista}
            history={this.props.history}
            onDelete={this.onDelete}
            pagination={pagination}
            imprimir={this.onImprimir}
            filtrarPorNombre={this.filtrarPorNombre}
            filtrarPorApellido={this.filtrarPorApellido}
            filtrarPorDocumento={this.filtrarPorDocumento}
            onChange={this.onChange}
            onDescargar={this.onDescargar}
            fechaInicio={this.state.fechaInicio}
            fechaFin={this.state.fechaFin}
            loadingTabla={this.state.loadingTabla}
            usuario={this.props.usuario}
            generarRecibo={this.generarRecibo}
          />
        )}

        {this.state.imprimir && (
          <ReImprimirNota
            datos={this.state.datosImpresion}
            idModeloNota={this.state.datosImpresion.modelo_nota._id}
            onCancel={() => this.setState({ ...this.state, imprimir: false })}
          />
        )}
      </div>
    );
  }
}

export default withApollo(VerAutorizacionesOtras);
